const widthDesktop = 400;
const widthDesktopHor = 1200;
export const scaleDesktop = (n: number, h = false): string => `${n / (h ? widthDesktopHor : widthDesktop) * 100}vw`;
